import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';


const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: "sm",
        backgroundColor: 'lightgray',
        padding: 0,
        margin: 0
    },
    inputsenores: {
        paddingTop: '3px'      
    },
    formControl: {
        // margin: theme.spacing(1),
        minWidth: 120,
        paddingTop: '3px',
        backgroundColor: 'green'
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
textfield: {
    paddingTop: '0px', 
    paddingBottom: '0px', 
    paddingLeft: '8px', 
    paddingRight: '8px'
},
selectJG: {
    '&::before': {
       paddingTop: '3px',
       backgroundColor: 'red'
      }
}

  
}));


export default function FormRoom(paxP, i) {

    const classes = useStyles();
    const [pax, setPax] = useState(paxP)
    const handleInputChange = event => {
        event.persist()
        const value = event.target.value;
        setPax({
            ...pax,
            [event.target.name]: value
        });
    }

    useEffect(() => {
          paxP.onChange(pax);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pax]);

    return (
        <Box display="flex" justifyContent="center" m={0} p={0} >
            <Box className={classes.textfield}>
                <TextField id="outlined-basic" label="Nombre" fullWidth name="Nombre" value={pax.Nombre}
                    size="small"
                    onChange={handleInputChange} 
                    InputProps={{
                        readOnly:paxP.bookingOkf
                      }}
                    
                    />
            </Box>
            <Box  className={classes.textfield}>
                <TextField id="outlined-basic" label="Apellido" fullWidth name="Apellido" value={pax.Apellido} onChange={handleInputChange}
                    size="small" 
                    InputProps={{
                        readOnly:paxP.bookingOkf
                      }}/>
            </Box>
            <Box  className={classes.textfield}>
                <TextField id="outlined-basic" label="Edad" fullWidth name="Edad" value={pax.Edad} onChange={handleInputChange}
                    size="small"
                    InputProps={{
                        readOnly:paxP.bookingOkf
                      }} />
            </Box>
        </Box>

    );
}
